import { useState, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { patientKeys } from '@/lib/queryKeys'

export function usePatientSearch() {
  const [query, setQuery] = useState('')
  const [debouncedQuery, setDebouncedQuery] = useState('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(query)
    }, 300)

    return () => clearTimeout(timer)
  }, [query])

  const isSearching = debouncedQuery.length >= 2

  const { data: allPatients, isLoading: isLoadingAll, error: listError, refetch: refetchAll } = useQuery({
    queryKey: patientKeys.list(),
    queryFn: () => providerApiClient.listPatients(),
    staleTime: 5 * 60 * 1000,
  })

  const { data: searchResults, isLoading: isSearchLoading, error: searchError, refetch: refetchSearch } = useQuery({
    queryKey: patientKeys.search(debouncedQuery),
    queryFn: () => providerApiClient.searchPatients(debouncedQuery),
    enabled: isSearching,
  })

  return {
    query,
    setQuery,
    results: isSearching ? searchResults : allPatients,
    isLoading: isSearching ? isSearchLoading : isLoadingAll,
    error: isSearching ? searchError : listError,
    refetch: isSearching ? refetchSearch : refetchAll,
  }
}
